import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import { useFormik, FormikProvider, Form, Field, ErrorMessage } from "formik";
import * as bie from "react-bootstrap";
import { config } from "../CommonUtils/CommonURLS";
import { CommonAxiosGet, CommonAxiosPost } from "../CommonUtils/CommonAxios";
import Swal from "sweetalert2";
import { failureAlert } from "../CommonUtils/SweetAlerts";
import { ERROR_MSG } from "../CommonUtils/contextVariables";
import CommonReactTable from "../CommonUtils/CommonReactTable";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin2Line } from "react-icons/ri";
import { showValue } from "./ParentSection";
export default function AddUniversityDtls() {
    const [isEdit, setIsEdit] = useState(false);

    const validationSchema = Yup.object({
        aisheCode: Yup.string().required(ERROR_MSG),
        univName: Yup.string().required(ERROR_MSG),
        dist: Yup.string().required(ERROR_MSG),
        website: Yup.string().required(ERROR_MSG),
        location: Yup.string().required(ERROR_MSG),
        yrOfEstablishment: Yup.string().required(ERROR_MSG),

    });

    const Univformik = useFormik({
        initialValues: {
            yrOfEstablishment: "",
            aisheCode: "",
            univName: "",
            univType: "State Public University",
            dist: "",
            state: "Andhra Pradesh",
            website: "",
            location: "",

        },
        validationSchema,
        onSubmit: (val) => {
            console.log("Submitted values:", val);
            val.yrOfEstablishment = parseInt(val.yrOfEstablishment || "", 10);
            Swal.fire({
                text: 'Are you sure you want to submit?',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: 'Yes, submit it!',
                cancelButtonText: 'No, cancel!',
                backdrop: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    let url = config.url.FAC_URL + `saveUniversity`
                    CommonAxiosPost(url, val).then((res) => {
                        if (res?.data?.scode === '01') {
                            Swal.fire(res?.data?.sdesc, '', 'success').then((res) => {

                            })
                        }
                        else if (res?.data?.scode === '02') {
                            Swal.fire(res?.data?.sdesc, '', 'error').then((res) => {
                            })
                        }
                        else {
                            failureAlert("Failed to submit")

                        }
                    })
                }
            });
        }
    });



    const [distlist, setDistlist] = useState([]);

    const fetchDistList = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getDistricts`
        );
        setDistlist(res?.data?.scode === "01" ? res.data.getDistricts : []);
    };


    const [univdata, setUnivdata] = useState([]);

    const GetUnivData = async () => {
        const res = await CommonAxiosGet(
            `${config.url.FAC_URL}getUniversityList`
        );
        setUnivdata(res?.data?.scode === "01" ? res.data.data : []);
    };






    useEffect(() => {
        fetchDistList();
        GetUnivData();
    }, []);


    const UnivColumns = [
        {
            id: "slNo",
            header: "Sl.No",
            cell: ({ row }) => row.index + 1,
        },
        {
            accessorKey: "univ_name",
            header: "University Name",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "yr_of_establishment",
            header: "Year of Establishment",
            meta: { style: { textAlign: "left" } },
            cell: ({ getValue }) => showValue(getValue())


        },
        {
            accessorKey: "dist",
            header: "District",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "type",
            header: "University Type",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "aishe_code",
            header: "AISHE Code",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "website",
            header: "Website",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "location",
            header: "Location",
            meta: { style: { textAlign: "left" } }

        },
        {
            accessorKey: "state",
            header: "State",
            meta: { style: { textAlign: "left" } }

        },



        {
            id: "actions",
            header: "Edit / Delete",
            cell: ({ row }) => {
                const rowData = row.original;
                console.log("val", rowData);

                return (
                    <div className="d-flex gap-2">
                        <button
                            type="button"
                            className="btn btn-primary btn-sm"
                            onClick={() => {
                                // GetUnivData(rowData?.construction_type);
                                Univformik.setValues({
                                    yrOfEstablishment: String(rowData?.yr_of_establishment || ""),
                                    aisheCode: rowData?.aishe_code,
                                    univName: rowData?.univ_name,
                                    univType: rowData?.type,
                                    dist: rowData?.dist,
                                    state: rowData?.state,
                                    website: rowData?.website,
                                    location: rowData?.location,


                                });

                                setIsEdit(true);
                                setEditId(rowData?.sno);
                            }}
                        >
                            <FaEdit size={16} />
                        </button>

                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => {
                                console.log("DELETE BUTTON CLICKED");
                                console.log("ROW DATA:", rowData);
                                console.log("SNO:", rowData?.sno);

                                // deleteWithConfirm({
                                //     sno: rowData?.sno,
                                //     apiPath: "deleteInfraWorks",
                                //     onSuccess: GetEquipData,
                                // });
                            }}
                        >
                            <RiDeleteBin2Line size={20} />
                        </button>

                    </div>
                );
            },
        }
    ];
    return (
        <>

            <div className="faculty-form-wrapper">
                <div className="faculty-card">
                    <h4 className="overal-stathead">
                        <span>Add University Details</span></h4>

                    <FormikProvider value={Univformik}>
                        <Form
                            className="form_adjust"
                            onSubmit={Univformik.handleSubmit}
                            onChange={Univformik.handleChange}
                        >
                            {/* ================= PERSONAL DETAILS ================= */}
                            <bie.Row>
                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Type of University</label>
                                    <Field
                                        as="select"
                                        name="univType"
                                        className="form-control"
                                    >
                                        <option value="State Public University">State Public University</option>

                                    </Field>
                                    <ErrorMessage name="univType" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>AISHE Code</label>
                                    <Field
                                        type="text"
                                        name="aisheCode"
                                        className="form-control"
                                    />

                                    <ErrorMessage name="aisheCode" component="div" className="text-danger" />
                                </bie.Col>



                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Name of University</label>
                                    <Field
                                        type="text"
                                        name="univName"
                                        className="form-control"
                                    />

                                    <ErrorMessage name="univName" component="div" className="text-danger" />
                                </bie.Col>


                                {/* <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>Name of University</label>
                                    <Field
                                        type="text"
                                        name="univName"
                                        className="form-control"
                                    />

                                    <ErrorMessage name="univName" component="div" className="text-danger" />
                                </bie.Col> */}

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>State</label>
                                    <Field
                                        as="select"
                                        name="state"
                                        className="form-control"
                                    >
                                        <option value="Andhra Pradesh">Andhra Pradesh</option>

                                    </Field>
                                    <ErrorMessage name="state" component="div" className="text-danger" />
                                </bie.Col>


                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4} className="mb-2">
                                    <label>District</label>
                                    <Field
                                        as="select"
                                        name="dist"
                                        className="form-control"
                                    >
                                        <option value="">---select---</option>
                                        {distlist?.map((d) => (
                                            <option key={d.dist_code} value={d.dist_code}>
                                                {d.dist_name}
                                            </option>
                                        ))}

                                    </Field>
                                    <ErrorMessage name="dist" component="div" className="text-danger" />
                                </bie.Col>


                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                    <label>Website  </label>
                                    <Field name="website" className="form-control" maxLength="30" />
                                    <ErrorMessage name="website" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                    <label>Year of Establishment  </label>
                                    <Field
                                        as="select"
                                        className="input-field form-control"
                                        name="yrOfEstablishment"
                                    >

                                        <option value="">--Select--</option>
                                        {Array.from({ length: 37 }, (_, i) => i + 1990).map((num) => (
                                            <option key={num} value={num}>
                                                {num}
                                            </option>
                                        ))}
                                    </Field>
                                    <ErrorMessage name="yrOfEstablishment" component="div" className="text-danger" />
                                </bie.Col>

                                <bie.Col xs={12} sm={12} md={12} lg={6} xl={4} xxl={4}>
                                    <label>Location  </label>
                                    <Field as="select" className="form-control" name="location">
                                        <option value="">---select---</option>
                                        <option value="urban">Urban</option>
                                        <option value="rural">Rural</option>

                                    </Field>
                                    <ErrorMessage name="location" component="div" className="text-danger" />
                                </bie.Col>
                            </bie.Row>

                            <div className="text-end mt-3">
                                <button type="submit" className="submit-btn">Submit</button>
                            </div>

                            {univdata?.length > 0 && (
                                <>

                                    <div className="overal-stathead">
                                        <span>University Details Report</span>
                                    </div>
                                    <div className="table-responsive ">
                                        <CommonReactTable
                                            data={univdata}
                                            columns={UnivColumns}
                                            filename="University Details Report"
                                            headerName="University Details Report"
                                            showFooter={false}
                                            showPagination={false}
                                            showExcel={true}
                                            showPrint={true}
                                            excelFileName="University Details Report"

                                        />
                                    </div>
                                </>
                            )}
                        </Form>
                    </FormikProvider>
                </div>
            </div>





        </>


    )
}
